import parseHTML from "../lib/dom/funciones/parse_html";
var bloqueaTabulador = function (menu, enlaces) {
    var detectorFocoInicio = parseHTML('<div tabindex="0"></div>'), detectorFocoFin = parseHTML('<div tabindex="0"></div>');
    menu.insertBefore(detectorFocoInicio, menu.firstChild);
    detectorFocoInicio.addEventListener('focus', function () { return enlaces[enlaces.length - 1].focus(); });
    menu.appendChild(detectorFocoFin);
    detectorFocoFin.addEventListener('focus', function () { return enlaces[0].focus(); });
};
var configuraAperturaYCierre = function (menu, enlaces) {
    var abrir = document.getElementById('menu-abrir'), cerrar = document.getElementById('menu-cerrar'), quita = function (ev) { return ev.target.remove(); }, padre = menu.parentElement, abreMenu = function () {
        padre.appendChild(menu);
        setTimeout(function () {
            menu.removeEventListener('transitionend', quita);
            abrir.setAttribute('aria-expanded', 'true');
            cerrar.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'false');
            menu.removeAttribute('inert');
            enlaces[1].focus();
        });
    }, cierraMenu = function () {
        cerrar.setAttribute('aria-expanded', 'true');
        abrir.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        abrir.focus();
        menu.setAttribute('inert', '');
        menu.addEventListener('transitionend', quita);
    };
    menu.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') {
            cerrar.click();
        }
    });
    menu.remove();
    abrir.addEventListener('click', abreMenu);
    cerrar.addEventListener('click', cierraMenu);
    enlaces
        .filter(function (x) {
        var href = x.getAttribute('href') || '';
        return href.indexOf('#') > -1 && !href.startsWith('http');
    })
        .forEach(function (x) { return x.addEventListener('click', cierraMenu); });
    return {
        abreMenu: abreMenu,
        cierraMenu: cierraMenu
    };
};
var configuraDesplegables = function (menu, unico) {
    var conHijos = [].slice.call(menu.querySelectorAll('.menu-item-has-children'));
    if (conHijos.length === 0) {
        return;
    }
    var oculta = function (ev) { return ev.target.hidden = true; }, abre = function (menuItem) {
        var boton = menuItem.querySelector('button'), subMenu = menuItem.querySelector('.sub-menu');
        boton.setAttribute('aria-pressed', 'true');
        subMenu.hidden = false;
        subMenu.style.height = subMenu.scrollHeight + 'px';
        subMenu.removeEventListener('transitionend', oculta);
    }, cierra = function (menuItem) {
        var boton = menuItem.querySelector('button'), subMenu = menuItem.querySelector('.sub-menu');
        boton.setAttribute('aria-pressed', 'false');
        subMenu.style.height = '0';
        subMenu.addEventListener('transitionend', oculta, { once: true });
    };
    conHijos.forEach(function (menuItem, i) {
        var enlace = menuItem.querySelector('a'), subMenu = menuItem.querySelector('.sub-menu'), agrupado = parseHTML("<div class=\"menu__enlace\"></div>"), boton = parseHTML("<button aria-controls=\"sub-menu-".concat(i, "\" aria-pressed=\"false\" role=\"button\" class=\"menu__desplegar\">\n        <svg viewBox=\"0 0 10 5\" width=\"20\" height=\"10\"><path d=\"M2 1L5 4L8 1\" stroke=\"currentColor\" fill=\"none\" /></svg>    \n    </button>")), cambia = function (e) {
            e.preventDefault();
            var estamosAbriendo = boton.getAttribute('aria-pressed') === 'false';
            if (estamosAbriendo && unico) {
                conHijos
                    .filter(function (x) { return x.querySelector('button'); })
                    .forEach(cierra);
            }
            estamosAbriendo ? abre(menuItem) : cierra(menuItem);
        };
        enlace.parentNode.replaceChild(agrupado, enlace);
        agrupado.appendChild(enlace);
        agrupado.appendChild(new Text(' '));
        agrupado.appendChild(boton);
        subMenu.setAttribute('id', "sub-menu-".concat(i));
        subMenu.style.height = '0';
        subMenu.hidden = true;
        boton.addEventListener('click', cambia);
        boton.setAttribute('aria-controls', subMenu.id);
    });
};
var configuraActualizacionDeAltura = function () {
    var ultimoScroll = -1, ultimoAltoCabecera = -1;
    var body = document.body, cabeceraPrincipal = document.querySelector('.cabeceraPrincipal'), actualizaCabecera = function () {
        if (ultimoScroll !== scrollY) {
            body.style.setProperty('--scroll', "".concat(scrollY, "px"));
            ultimoScroll = scrollY;
        }
        if (ultimoAltoCabecera !== cabeceraPrincipal.offsetHeight) {
            var altura = cabeceraPrincipal.getBoundingClientRect().bottom;
            body.style.setProperty('--alto-cabecera', "".concat(altura, "px"));
            ultimoAltoCabecera = altura;
        }
        requestAnimationFrame(actualizaCabecera);
    };
    actualizaCabecera();
};
var menu = function (unico) {
    if (unico === void 0) { unico = true; }
    var menu = document.getElementById('menu-movil'), enlaces = [].slice.call(menu.querySelectorAll('a, button'));
    bloqueaTabulador(menu, enlaces);
    configuraDesplegables(menu, unico);
    configuraActualizacionDeAltura();
    return configuraAperturaYCierre(menu, enlaces);
};
export default menu;
